<template>
  <aside class="site-sidebar" :class="'site-sidebar--' + sidebarLayoutSkin">
    <div class="site-sidebar__inner">
      <el-menu
        :default-active="menuActiveName || 'home'"
        :collapse="sidebarFold"
        :unique-opened="true"
        :collapseTransition="false"
        class="site-sidebar__menu">
        <el-menu-item index="home" @click="$router.push({ name: 'home' })">
          <icon-svg name="shouye" class="site-sidebar__menu-icon"></icon-svg>
          <span slot="title">首页</span>
        </el-menu-item>
        <sub-menu
          :menuPopup="false"
          v-for="menu in currentMenuList"
          :key="menu.menuId"
          :menu="menu"
          :dynamicMenuRoutes="dynamicMenuRoutes">
        </sub-menu>
      </el-menu>
    </div>
<!--      <el-menu style="background-color: #0a1b40;">-->
<!--          <el-menu-item v-if="hasLogin" class="site-navbar__switch" index="0" @click="sidebarFold = !sidebarFold" style="border-top: 1px solid rgba(255, 255, 255, 0.25);display: flex;justify-content: flex-end;align-items: center;height: 40px;background: #0a1b40;color: #fff;">-->

<!--          </el-menu-item>-->
<!--      </el-menu>-->
      <div style="border-top: 1px solid rgba(255, 255, 255, 0.25);display: flex;justify-content: flex-end;align-items: center;height: 40px;background: #0a1b40;color: #fff;padding: 0 20px;cursor:pointer;" v-if="hasLogin" @click="sidebarFold = !sidebarFold">
          <icon-svg name="zhedie"></icon-svg>
      </div>
  </aside>
</template>

<script>
  import SubMenu from './main-sidebar-sub-menu'
  import {isURL} from '@/utils/validate'

  export default {
    data() {
      return {
        dynamicMenuRoutes: [],
        currentMenuList: [],
        oldTabIndex:0
      }
    },
    components: {
      SubMenu
    },
    computed: {
        hasLogin: {
            get () { return this.$store.state.user.id !== '' && this.$store.state.user.id !== undefined }
        },
      sidebarLayoutSkin: {
        get() {
          return this.$store.state.common.sidebarLayoutSkin
        }
      },
        sidebarFold: {
            get () { return this.$store.state.common.sidebarFold },
            set (val) { this.$store.commit('common/updateSidebarFold', val) }
        },
      topNavIndex: {
        get () { return this.$store.state.common.topNavIndex },
      },
      menuList: {
        get() {
          return this.$store.state.common.menuList
        },
        set(val) {
          this.$store.commit('common/updateMenuList', val)
        }
      },
      menuActiveName: {
        get() {
          return this.$store.state.common.menuActiveName
        },
        set(val) {
          this.$store.commit('common/updateMenuActiveName', val)
        }
      },
      mainTabs: {
        get() {
          return this.$store.state.common.mainTabs
        },
        set(val) {
          this.$store.commit('common/updateMainTabs', val)
        }
      },
      mainTabsActiveName: {
        get() {
          return this.$store.state.common.mainTabsActiveName
        },
        set(val) {
          this.$store.commit('common/updateMainTabsActiveName', val)
        }
      }
    },
    watch: {
      $route: 'routeHandle',
      '$store.state.common.topNavIndex': function () {
        if(this.oldTabIndex!==this.topNavIndex){
          this.oldTabIndex=this.topNavIndex
          this.loadMenuList()
        }
      }
    },
    created() {
      this.oldTabIndex=this.topNavIndex
      this.loadMenuList()
    },

    methods: {
      loadMenuList(){
        this.menuList = JSON.parse(sessionStorage.getItem('menuList') || '[]')
        this.currentMenuList = this.menuList;
        this.dynamicMenuRoutes = JSON.parse(sessionStorage.getItem('dynamicMenuRoutes') || '[]')
        this.routeHandle(this.$route)
      },
        // 路由操作
        routeHandle(route) {
            if (route.meta.isTab) {
                let routeName = route.name
                let tabName = routeName
                if (!route.meta.isDynamic && route.params && route.meta.single !== true) {
                    let extname = ''
                    for (var argname in route.params) {
                        if (route.params[argname]) {
                            extname += '_' + route.params[argname]
                        }
                    }
                    // tabName = tabName + extname
                }
                // tab选中, 不存在先添加
                var tab = this.mainTabs.filter(item => item.name === tabName)[0]
                if (!tab) {
                    if (route.meta.isDynamic) {
                        route = this.dynamicMenuRoutes.filter(item => item.name === tabName)[0]
                        if (!route) {
                            return console.error('未能找到可用标签页!')
                        }
                    }
                    let title = route.meta.title
                    if (route.params && route.params.title) {
                        title = route.params.title
                    }
                    tab = {
                        menuId: route.meta.menuId || tabName,
                        name: tabName,
                        routeName: routeName,
                        params: route.params || {}, //用于记录路由参数
                        title: title,
                        type: isURL(route.meta.iframeUrl) ? 'iframe' : 'module',
                        iframeUrl: route.meta.iframeUrl || ''
                    }
                    this.mainTabs = this.mainTabs.concat(tab)
                }
                this.menuActiveName = tab.menuId + ''
                this.mainTabsActiveName = tabName
            }
        }
    }
  }
</script>
<style lang="scss" scoped>
.el-menu-item:hover{
    color: #fff!important;
    background-color: #1890FF !important;
}
.el-menu-item, .el-submenu__title{
    height: 44px;
    line-height: 44px;
    margin: 0 0 8px 0;
}
</style>
